import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sync-page" }
const _hoisted_2 = { class: "sync-layout" }
const _hoisted_3 = { class: "main-content" }
const _hoisted_4 = { style: {"text-align":"center","padding":"32px 0"} }

import { ref } from 'vue'
import SystemSideMenu from '@/components/SystemSideMenu.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'SyncManager',
  setup(__props) {

const tabKey = ref('up')

const columns = [
  { title: 'ID', dataIndex: 'id', key: 'id' },
  { title: '同步对象', dataIndex: 'target', key: 'target' },
  { title: '同步模式', dataIndex: 'mode', key: 'mode' },
  { title: '创建时间', dataIndex: 'createdAt', key: 'createdAt' },
  { title: '操作', key: 'action' }
]

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "sync-title" }, "同步中心", -1)),
            _createVNode(_component_a_tabs, {
              activeKey: tabKey.value,
              "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((tabKey).value = $event)),
              style: {"margin-bottom":"16px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_tab_pane, {
                  key: "up",
                  tab: "上游同步"
                }),
                _createVNode(_component_a_tab_pane, {
                  key: "down",
                  tab: "同步到下游"
                })
              ]),
              _: 1
            }, 8, ["activeKey"]),
            _createVNode(_component_a_button, {
              type: "primary",
              style: {"margin-bottom":"16px"}
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("创建同步任务")
              ])),
              _: 1
            }),
            _createVNode(_component_a_table, {
              columns: columns,
              "data-source": [],
              pagination: false,
              size: "middle",
              style: {"margin-top":"8px"}
            }, {
              emptyText: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_a_empty, { description: "暂无数据" })
                ])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})